import { Button, Grid, Icon, List, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Finance/PaymentProfiles/List/subcomponents/List/payment-profiles-list.module.scss'
import { useTableConfig } from 'modules/Finance/PaymentProfiles/List/subcomponents/List//hooks/useTableConfig'
import GridSpinner from 'components/UI/GridSpinner'

const PaymentProfilesList = ({ data, loading, onChangePage, pagination, EmptyComponent }) => {
  const { t } = useTranslation()

  const { tableState, tableConfig } = useTableConfig(
    { className: styles['payment-profiles-list'] },
    data,
  )

  return (
    <>
      <List
        Loader={() => <GridSpinner width={24} />}
        loading={loading}
        table={tableState}
        config={tableConfig}
        EmptyComponent={EmptyComponent}
      />
      {pagination.total !== data.length && (
        <div className={styles['pagination']}>
          <Grid
            alignItems={'center'}
            justifyContent={'center'}
            className={styles['show-more__container']}
          >
            <Button
              onClick={onChangePage}
              className={styles['show-more__button']}
              variant={'link'}
              startIcon={
                loading ? (
                  <Spinner
                    width={16}
                    color={'inherit'}
                  />
                ) : null
              }
              endIcon={
                <Icon
                  name={'arrow1-down'}
                  color={'inherit'}
                  size={'s'}
                />
              }
            >
              {t('common::pagination.show_more')}
            </Button>
          </Grid>
        </div>
      )}
    </>
  )
}

PaymentProfilesList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  pagination: PropTypes.object,
  EmptyComponent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
}

export default PaymentProfilesList
